var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInformtion(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13 2C6.92487 2 2 6.92487 2 13C2 19.0751 6.92487 24 13 24C19.0751 24 24 19.0751 24 13C24 6.92487 19.0751 2 13 2ZM0 13C0 5.82029 5.82029 0 13 0C20.1797 0 26 5.82029 26 13C26 20.1797 20.1797 26 13 26C5.82029 26 0 20.1797 0 13ZM13 12C13.5523 12 14 12.4477 14 13V17.6667C14 18.2189 13.5523 18.6667 13 18.6667C12.4477 18.6667 12 18.2189 12 17.6667V13C12 12.4477 12.4477 12 13 12ZM13 7.66667C12.2636 7.66667 11.6667 8.26363 11.6667 9C11.6667 9.73637 12.2636 10.3333 13 10.3333H13.0133C13.7497 10.3333 14.3467 9.73637 14.3467 9C14.3467 8.26363 13.7497 7.66667 13.0133 7.66667H13Z",
    fill: "#29348F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInformtion);
export default __webpack_public_path__ + "static/media/informtion.f4209dd9d8abc793bd2ca487e966155e.svg";
export { ForwardRef as ReactComponent };